const RateStyle = require('../../module/rate-style');
const { getRect } = require('../../module/rect');

/**
 * Parallax
 * @class
 */
class Parallax {

  /**
   * @static
   */
  static get defOpts() {
    return {
      fps     : 30,
      moveRate: 0.2,
    }
  }

  /**
   * @param _$$el {HTMLElement}
   * @param _parallaxOpt {object}
   * @param _opts {object}
   */
  constructor(_$$el, _parallaxOpt, _opts = {}) {
    const { fps, moveRate } = _.defaultsDeep(_opts, Parallax.defOpts);

    this.$$el = _$$el;

    this.elms = {};

    this.ms            = 1000 / fps;
    this.moveRate      = moveRate;
    this.startTime     = 0;
    this.animateHandle = 0;
    this.isAnimate     = false;

    this.points    = {};
    this.ranges    = {};
    this.rates     = {};
    this.nextRates = {};


    _.forEach(this.$$el, (_$el) => {
      const name_ = _$el.dataset.parallaxName;

      this.points[name_]    = {};
      this.ranges[name_]    = 0;
      this.rates[name_]     = 0;
      this.nextRates[name_] = 0;

      this.elms[name_] = _$el;
    });

    this.rateStyles = this.createRateStyle(_parallaxOpt);

    this.reset();

    window.addEventListener('scroll', this.observeScroll.bind(this));
    window.addEventListener('resize', this.reset.bind(this));

    this.start();
  }

  /**
   * @private
   */
  createRateStyle(_data) {
    return _.reduce(_data, (_obj, _val, _key) => {
      _obj[_key] = new RateStyle(this.elms[_key], _val);
      return _obj;
    }, {});
  }

  /**
   * @private
   */
  observeScroll() {
    const winScrollY_ = window.pageYOffset;

    _.forEach(this.ranges, (_range, _name) => {
      const rate_ = (winScrollY_ - this.points[_name].top) / _range;

      if(0 > rate_) {
        this.rates[_name] = 0;
      } else if(1 < rate_) {
        this.rates[_name] = 1;
      } else {
        this.rates[_name] = rate_;
      }
    });

    this.start();
  }

  /**
   * @private
   */
  reset() {
    _.forEach(this.elms, (_$el, _name) => {
      const rect_ = getRect(_$el);

      this.points[_name] = {
        top   : (rect_.top - window.innerHeight),
        bottom: rect_.bottom,
      }
      this.ranges[_name] = this.points[_name].bottom - this.points[_name].top;
    });
  }

  /**
   * @private
   */
  start() {
    if(this.isAnimate) return;
    this.isAnimate = true;
    this.animate();
  }

  /**
   * @private
   */
  stop() {
    if(!this.isAnimate) return;
    this.isAnimate = false;
    window.cancelAnimationFrame(this.animateHandle);
  }

  /**
   * @private
   */
  animate() {
    if(this.ms >= (new Date().getTime() - this.startTime)) {
      this.animateHandle = window.requestAnimationFrame(this.animate.bind(this));
      return;
    };

    this.animateHandle = window.requestAnimationFrame(this.animate.bind(this));
    this.startTime = new Date().getTime();

    _.forEach(this.rateStyles, (_rateStyle, _name) => {
      this.nextRates[_name] += (this.rates[_name] - this.nextRates[_name]) * this.moveRate;
      _rateStyle.set(this.nextRates[_name]);
      if((Math.round(this.rates[_name] * 10000) / 10000) === (Math.round(this.nextRates[_name] * 10000) / 10000)) {
        this.stop();
      }
    });
  }

}

/**
 * class exports
 */
module.exports = Parallax;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/pc/ui/parallax.js
 **/